var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgCircularHole = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 103.417,
    height: 98.721,
    viewBox: "0 0 103.417 98.721",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3",
    "data-name": "Group 3",
    transform: "translate(-757.879 -679.675)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "dry-clean",
    transform: "translate(759.379 681.175)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1",
    "data-name": "Group 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1",
    "data-name": "Path 1",
    d: "M39.456,0A39.456,39.456,0,1,0,78.913,39.456,39.61,39.61,0,0,0,39.456,0Z",
    fill: "#8cbd8b",
    stroke: "#000",
    strokeWidth: 3
  }))), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2",
    "data-name": "Rectangle 2",
    width: 36.617,
    height: 36.617,
    rx: 4,
    transform: "translate(824.679 741.78)",
    fill: "#d5bc4d"
  }), /*#__PURE__*/React.createElement("g", {
    id: "delete_2_",
    "data-name": "delete (2)",
    transform: "translate(833.914 749.256)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    "data-name": "Path 4",
    d: "M222.908,154.7a.509.509,0,0,0-.509.509v9.628a.509.509,0,0,0,1.019,0v-9.628A.509.509,0,0,0,222.908,154.7Zm0,0",
    transform: "translate(-211.069 -146.822)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    "data-name": "Path 5",
    d: "M104.908,154.7a.509.509,0,0,0-.509.509v9.628a.509.509,0,1,0,1.019,0v-9.628A.509.509,0,0,0,104.908,154.7Zm0,0",
    transform: "translate(-99.08 -146.822)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6",
    "data-name": "Path 6",
    d: "M1.444,6.475V19.026a2.811,2.811,0,0,0,.747,1.938,2.509,2.509,0,0,0,1.82.787H13.65a2.508,2.508,0,0,0,1.82-.787,2.811,2.811,0,0,0,.747-1.938V6.475a1.946,1.946,0,0,0-.5-3.827H13.11V2.011A2,2,0,0,0,11.092,0H6.569A2,2,0,0,0,4.551,2.011v.637H1.943a1.946,1.946,0,0,0-.5,3.827ZM13.65,20.733H4.011a1.613,1.613,0,0,1-1.549-1.707V6.519H15.2V19.026A1.613,1.613,0,0,1,13.65,20.733ZM5.57,2.011a.981.981,0,0,1,1-.993h4.524a.981.981,0,0,1,1,.993v.637H5.57ZM1.943,3.667H15.718a.917.917,0,0,1,0,1.834H1.943a.917.917,0,0,1,0-1.834Zm0,0",
    transform: "translate(0.003 0.001)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7",
    "data-name": "Path 7",
    d: "M163.908,154.7a.509.509,0,0,0-.509.509v9.628a.509.509,0,1,0,1.019,0v-9.628A.509.509,0,0,0,163.908,154.7Zm0,0",
    transform: "translate(-155.074 -146.822)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 1
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgCircularHole, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/circular_hole.93ebfc79.svg";
export { ForwardRef as ReactComponent };